import "./App.css";
import SentinelNav from "./components/SentinelNav";
import SentinelFooter from "./components/SentinelFooter";
import Sentinel from "./pages/Sentinel";

function App() {
  return (
    <div className="App" id="top">
      <SentinelNav />
      <Sentinel />
      <SentinelFooter />
    </div>
  );
}

export default App;
